// extracted by mini-css-extract-plugin
export default {"wrapper":"cv_dv","container":"cv_d","dot":"cv_f5","isActive":"cv_f2"};